<template>
  <div class="publicity">
    <el-card shadow="always">
      <div class="title">
        <div class="lef">宣传海报</div>
        <template v-if="checkAdmin()">
          <el-upload
            ref="upload"
            :format="['jpg', 'png', 'psd']"
            accept=".jpg, .JPG, .png, .PNG, .psd, .PSD"
            :action="uploadHost"
            :data="uploadData"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :clearFiles="clearFiles"
            :on-error="handleFormatError"
          >
            <el-button
              slot="trigger"
              :disabled="uploadProgress"
              size="small"
              type="primary"
              >上传海报</el-button
            >
          </el-upload>
        </template>
      </div>
      <div>
        <div class="infinite-list-wrapper" style="overflow: auto">
          <div
            class="list"
            v-infinite-scroll="load"
            infinite-scroll-disabled="disabled"
          > 
            <template v-if="checkAdmin()">
              <div v-for="(item, index) in data" class="list-item" :key="index">
                <img :src="item.url" alt="" />
                <div class="mask_box">
                  <i class="el-icon-delete" @click="handleDelete(item.id)"></i>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-for="(item, index) in data" class="list-item" :key="index">
                <el-image
                  style="width: 250px; height: 380px"
                  :src="item.url"
                  :preview-src-list="[item.url]"
                >
                </el-image>
              </div>
            </template>
          </div>
          <!-- <p v-if="loading">加载中...</p>
          <p v-if="noMore">没有更多了</p> -->
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
import {
  getCmsPropagandaListPage,
  addCmsPropaganda,
  delCmsPropaganda,
} from "@/api/marketingAdmin/publicity.js";
export default {
  data() {
    return {
      count: 10,
      loading: false,
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 1,
      },
      // 附件上传路径
      uploadHost: "",
      type: 0,
      path: "public/product/",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      uploadProgress: false,
    };
  },
  created() {
    this.getCmsPropagandaListPage({ ...this.pageInfo });
  },
  computed: {
    noMore() {
      return this.pageInfo.page >= this.pageInfo.pages;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该宣传素材吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCmsPropaganda({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.getCmsPropagandaListPage({ page: 1, limit: this.data.length });
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 请求列表
    async getCmsPropagandaListPage(payload) {
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      delete payload.total;
      delete payload.pages;
      const res = await getCmsPropagandaListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.pageInfo.pages = Number(res.data?.pages) || 0;
      this.loading = false;
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.pageInfo.limit += 10;
        this.getCmsPropagandaListPage({ ...this.pageInfo });
      }, 2000);
    },
    // 添加宣传素材
    addCmsPropaganda(url) {
      addCmsPropaganda({ url }).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: "success",
            message: "上传成功!",
          });
          this.pageInfo.limit += 1;
          this.getCmsPropagandaListPage({ ...this.pageInfo });
          this.uploadProgress = false;
        }
      });
    },
    beforeUpload(file) {
      this.uploadProgress = true;
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
        this.fileData.fileUrl = res.key;
      });
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res;
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data;
            this.fileData.name = this.fileData.fileName;
            this.fileData.url = res.data;
            this.addCmsPropaganda(res.data);
          } else {
            this.$message.success("获取图片链接失败");
          }
        });
      }
    },
    clearFiles() {
      this.fileData = {
        fileName: "",
        fileUrl: "",
        uploadRes: null,
      };
    },
    handleFormatError(file) {
      this.$message({
        message: "图片格式错误",
        type: "warning",
      });
      this.uploadProgress = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.publicity {
  .title {
    display: flex;
    align-items: center;
    padding: 0 18px 20px;
    box-sizing: border-box;
    .lef {
      flex: 1;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
  }
  .list-item {
    width: 250px;
    height: 380px;
    margin: 0 13px;
    margin-bottom: 20px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .mask_box {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      .el-icon-delete {
        color: #ffffff;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
  .list-item:hover .mask_box {
    opacity: 1;
  }
}
</style>